import { render } from "./opportunity-talents-list.vue?vue&type=template&id=50f52883&ts=true"
import script from "./opportunity-talents-list.vue?vue&type=script&lang=ts"
export * from "./opportunity-talents-list.vue?vue&type=script&lang=ts"

import "./opportunity-talents-list.vue?vue&type=style&index=0&id=50f52883&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__